var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewGrid = function SvgViewGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V0h14v14H0zM2 2v10h10V2H2zM0 30V16h14v14H0zm2-12v10h10V18H2zm14 12V16h14v14H16zm2-12v10h10V18H18zM16 0h14v14H16V0zm12 12V2H18v10h10z",
    fillRule: "evenodd"
  })));
};
export default SvgViewGrid;